import React, { Fragment } from "react";
import { blogDetails, commentsData } from "../Data/Blogdata/Blogdata";
import { Link } from "react-router-dom";
import CommentForm from "./Commentform";
import { Col, Row } from "reactstrap";

const BlogDetailsContent = () => {
  return (
    <Fragment>
      <div className='blog-details news-slid'>
        <div className='news-box'>
          <img src='assets/images/blog/1.jpg' alt='news-1' className='img-fluid' />
        </div>
        <div className='news-text'>
          <div className='blog-hover'>
            <h4>{blogDetails.title}</h4>
            <ul className='list-inline blog-details-list'>
              <li>
                <Link className={blogDetails.class}>{blogDetails.author}</Link>
              </li>
              <li>
                <Link className={blogDetails.class}>{blogDetails.date}</Link>
              </li>
              <li>
                <Link className={blogDetails.class}>{blogDetails.comments}</Link>
              </li>
              <li>
                <Link className={blogDetails.class}>{blogDetails.views}</Link>
              </li>
            </ul>
          </div>
          <p>{blogDetails.content}</p>
          <p>{blogDetails.content}</p>
        </div>
      </div>
      <div className='blog-divider'></div>
      <div className='reply-comment'>
        {commentsData.map((comment, index) => (
          <div className='media d-flex align-items-start' key={index}>
            <img className='align-self-top me-3' src={comment.imageUrl} alt='blog' />
            <div className='media-body'>
              <Link className='text-decoration-none'>
                <h5 className='mt-0'>{comment.author}</h5>
              </Link>
              <p>{comment.content}</p>
            </div>
          </div>
        ))}
      </div>
      <div className='blog-divider'></div>
      <Row>
        <Col md='10' className='offset-md-1 leave-comment'>
          <h3 className='text-center'>Leave Your Comment</h3>
          <CommentForm />
        </Col>
      </Row>
    </Fragment>
  );
};

export default BlogDetailsContent;
